module.exports = "/assets/pattern-fdw-tile@2x.png?gz1HZsb";